import { useCallback, useEffect, useState } from "react";

/** MUI */
import makeStyles from "@mui/styles/makeStyles";

/** Redux */
import { setScroll } from "@/src/_appStore/Common";
import { open } from "@/src/_appStore/utils/_idb_COMMON";
import { stores } from "@/src/_appStore/utils/stores";
import { useDispatch } from "react-redux";
// import { fetchCommonFromIndexedDB } from "@/src/_appStore/utils/fetch";

import {
    fetchAggregatesFromIndexedDB,
    fetchAreasFromIndexedDB,
    fetchCalendarFromIndexedDB,
    fetchCATCalculatorsFromIndexedDB,
    fetchCATCommonFromIndexedDB,
    fetchChartsFiltersFromIndexedDB,
    fetchCommonFromIndexedDB,
    fetchDATESFromIndexedDB,
    fetchDBCommonFromIndexedDB,
    fetchJTFromIndexedDB,
    fetchListsTableFromIndexedDB,
    fetchRepositoryromIndexedDB,
    fetchSettingsChartBarsFromIndexedDB,
    fetchSettingsTableFromIndexedDB,
    fetchStorytellingFromIndexedDB,
    fetchTableFiltersFromIndexedDB,
    fetchVALCommonFromIndexedDB,
    fetchWSKFromIndexedDB,
} from "@/src/_appStore/utils/fetch";

/** UI */
import PagePreloader from "@/src/_common/PagePreloader";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import "overlayscrollbars/overlayscrollbars.css";

const useStyles = makeStyles((theme) => ({
    osScrollbar: {
        height: "100vh",
        "& > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle, & > .os-scrollbar:hover > .os-scrollbar-track > .os-scrollbar-handle":
            {
                background: "#919090",
            },

        "& > .os-scrollbar.os-scrollbar-vertical": {
            padding: 10,
            width: 24,
            transition: "all 0.125s linear",
            "&:hover": {
                padding: 6,
                cursor: "s-resize",
            },
        },
    },
}));

const App = (props) => {
    const { Router, storeReady } = props;
    const classes = useStyles();
    const dispatch = useDispatch();

    const [dbReady, setDbReady] = useState(false);

    const fetchAllIDB = useCallback(async () => {
        const _checked = true; // await checkIDB();
        process.env.NODE_ENV === "development" &&
            console.log(
                `%c Check iDB: ${_checked ? "OK. " : "no iDB found "}`,
                `background: ${_checked ? "#0B0" : "#B00"}; color: #FFF`
            );

        if (_checked) {
            const fetch = await fetchIDB();
            const { _fetched, res } = fetch || {};

            process.env.NODE_ENV === "development" &&
                console.log(
                    `%c Fetch iDBs: ${_fetched ? "OK. " : "Oops..."}`,
                    `background: ${_fetched ? "#0B0" : "#B00"}; color: #FFF`,
                    _fetched ? "" : res
                );
            if (!_fetched) {
                Router.reload();
                // fetchAllIDB()
            }
        }
    });

    useEffect(() => {
        if (storeReady) {
            fetchAllIDB();
        }

        return () => {
            setDbReady(false);
        };
    }, [storeReady]);

    const fetchIDB = async () => {
        try {
            return await Promise.all([
                dispatch(fetchAggregatesFromIndexedDB()),
                dispatch(fetchAreasFromIndexedDB()),
                dispatch(fetchCalendarFromIndexedDB()),
                dispatch(fetchCATCalculatorsFromIndexedDB()),
                dispatch(fetchCATCommonFromIndexedDB()),
                dispatch(fetchChartsFiltersFromIndexedDB()),
                dispatch(fetchCommonFromIndexedDB()),
                dispatch(fetchDATESFromIndexedDB()),
                dispatch(fetchDBCommonFromIndexedDB()),
                dispatch(fetchJTFromIndexedDB()),
                dispatch(fetchListsTableFromIndexedDB()),
                dispatch(fetchSettingsChartBarsFromIndexedDB()),
                dispatch(fetchSettingsTableFromIndexedDB()),
                dispatch(fetchRepositoryromIndexedDB()),
                dispatch(fetchStorytellingFromIndexedDB()),
                dispatch(fetchTableFiltersFromIndexedDB()),
                dispatch(fetchVALCommonFromIndexedDB()),
                dispatch(fetchWSKFromIndexedDB()),
            ])
                .then((res) => {
                    const _fetched = res.every((r) => !!r && !r?.error);
                    // process.env.NODE_ENV === "development" && console.log("fetchIDB then: ", res, { _fetched });
                    setDbReady(_fetched);
                    return { _fetched, res };
                })
                .catch(
                    (err) =>
                        process.env.NODE_ENV === "development" &&
                        console.log("%c fetchIDB: error", "background:#F00", err)
                )
                .finally(() => {});
        } catch (error) {}
    };

    return dbReady ? (
        <OverlayScrollbarsComponent
            element="span"
            options={{
                scrollbars: {
                    autoHide: "move",
                    autoHideDelay: 666,
                },
            }}
            events={{
                scroll: (a, event) => {
                    dispatch(setScroll(event.target?.scrollTop));
                },
                initialized: (a, b, c) => {
                    dispatch(setScroll(0));
                },
            }}
            defer
            className={classes.osScrollbar}
            id="appScroll"
        >
            {props.children}
        </OverlayScrollbarsComponent>
    ) : (
        <PagePreloader />
    );
};

export default App;
